module.exports = __webpack_public_path__ + "img/redbag_hand_down.2aefd943.png";